import React from 'react';
import { Text } from 'ink';
import type { AgentTreeView } from '../../types';

interface SubAgentIndicatorProps {
  agentTree?: AgentTreeView;
  dimColor?: boolean;
}

/** Returns true when at least one direct child of the root is currently running. */
export function hasRunningSubAgent(agentTree: AgentTreeView): boolean {
  return agentTree.root.children.some((child) => child.status === 'running');
}

/**
 * Shows a "Sub agent running" indicator in the status bar footer when at least
 * one child agent is currently running. Renders nothing when there is no agent
 * tree or no running sub-agents.
 */
export const SubAgentIndicator: React.FC<SubAgentIndicatorProps> = React.memo(
  ({ agentTree, dimColor }) => {
    if (!agentTree) return null;

    if (!hasRunningSubAgent(agentTree)) return null;

    return <Text dimColor={dimColor}>Sub agent running</Text>;
  },
);
